module.exports = __webpack_public_path__ + "static/media/IconSpotify.6f9ec2ab.svg";